<template>
  <div class="">
    <Movementmenu_govem/>
    <!-- Header Section -->
    <v-container fluid>
      <v-card class="hero-card mb-6" elevation="0" color="gradient">
        <v-card-text class="pa-8">
          <v-row align="center">
            <v-col cols="12" md="8">
              <div class="hero-content">
                <h1 class="hero-title white--text mb-2">
                  📊 ระบบสรุปข้อมูลอัตรากำลังรับย้าย
                </h1>
                <p class="hero-subtitle white--text text--lighten-2 mb-0">
                  Government Employee Transfer Management Dashboard
                </p>
                <div class="d-flex align-center mt-4">
                  <v-chip color="white" text-color="primary" small class="mr-2">
                    <v-icon small left>mdi-update</v-icon>
                    อัพเดทล่าสุด: {{ lastUpdated }}
                  </v-chip>
                  <v-chip color="rgba(255,255,255,0.2)" text-color="white" small>
                    <v-icon small left>mdi-database</v-icon>
                    {{ totalPositions }} รายการ
                  </v-chip>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="text-center">
              <div class="hero-stats">
                <div class="big-number white--text">
                  {{ occupancyRate }}%
                </div>
                <div class="white--text text--lighten-2">อัตราการครอบครอง</div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Stats Cards Section -->
    <v-container fluid>
      <v-row class="mb-6">
        <!-- Total Positions Card -->
        <v-col cols="12" sm="6" md="3">
          <v-card 
            class="stat-card-modern total-card" 
            elevation="8"
            :class="{ 'card-hover': true }"
          >
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="stat-label grey--text text--darken-1 mb-1">
                    รวมตำแหน่งทั้งหมด
                  </div>
                  <h2 class="stat-number primary--text text--darken-2">
                    {{ totalPositions.toLocaleString() }}
                  </h2>
                  <div class="trend-indicator positive">
                    <v-icon small color="success">mdi-trending-up</v-icon>
                    <span class="text-caption success--text">+12%</span>
                  </div>
                </div>
                <div class="stat-icon-container total-bg">
                  <v-icon size="32" color="white">mdi-account-group</v-icon>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Available Positions Card -->
        <v-col cols="12" sm="6" md="3">
          <v-card 
            class="stat-card-modern available-card" 
            elevation="8"
            :class="{ 'card-hover': true }"
          >
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="stat-label grey--text text--darken-1 mb-1">
                    ตำแหน่งว่าง
                  </div>
                  <h2 class="stat-number warning--text text--darken-2">
                    {{ availablePositions.toLocaleString() }}
                  </h2>
                  <div class="trend-indicator">
                    <v-icon small color="warning">mdi-minus</v-icon>
                    <span class="text-caption warning--text">-3%</span>
                  </div>
                </div>
                <div class="stat-icon-container available-bg">
                  <v-icon size="32" color="white">mdi-account-plus</v-icon>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Occupied Positions Card -->
        <v-col cols="12" sm="6" md="3">
          <v-card 
            class="stat-card-modern occupied-card" 
            elevation="8"
            :class="{ 'card-hover': true }"
          >
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="stat-label grey--text text--darken-1 mb-1">
                    ตำแหน่งที่มีผู้ครอง
                  </div>
                  <h2 class="stat-number success--text text--darken-2">
                    {{ occupiedPositions.toLocaleString() }}
                  </h2>
                  <div class="trend-indicator positive">
                    <v-icon small color="success">mdi-trending-up</v-icon>
                    <span class="text-caption success--text">+8%</span>
                  </div>
                </div>
                <div class="stat-icon-container occupied-bg">
                  <v-icon size="32" color="white">mdi-account-check</v-icon>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Occupancy Rate Card -->
        <v-col cols="12" sm="6" md="3">
          <v-card 
            class="stat-card-modern percentage-card" 
            elevation="8"
            :class="{ 'card-hover': true }"
          >
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="stat-label grey--text text--darken-1 mb-1">
                    อัตราการครอบครอง
                  </div>
                  <h2 class="stat-number info--text text--darken-2">
                    {{ occupancyRate }}%
                  </h2>
                  <div class="progress-mini mt-2">
                    <v-progress-linear
                      :value="occupancyRate"
                      color="info"
                      height="4"
                      rounded
                    ></v-progress-linear>
                  </div>
                </div>
                <div class="stat-icon-container percentage-bg">
                  <v-icon size="32" color="white">mdi-chart-line</v-icon>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Charts Section -->
      <v-row class="mb-6">
        <!-- Donut Chart -->
        <v-col cols="12" md="6">
          <v-card class="chart-card-modern" elevation="8">
            <v-card-title class="chart-header pa-6">
              <div class="d-flex align-center">
                <div class="chart-icon-bg donut-bg mr-3">
                  <v-icon color="white">mdi-chart-donut</v-icon>
                </div>
                <div>
                  <h3 class="chart-title mb-1">สถานะตำแหน่ง</h3>
                  <p class="chart-subtitle grey--text mb-0">แสดงสัดส่วนตำแหน่งว่างและที่มีผู้ครอง</p>
                </div>
              </div>
            </v-card-title>
            <v-card-text class="pa-6 pt-0">
              <apexchart
                type="donut"
                :options="modernDonutOptions"
                :series="donutSeries"
                height="350"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Bar Chart -->
        <v-col cols="12" md="6">
          <v-card class="chart-card-modern" elevation="8">
            <v-card-title class="chart-header pa-6">
              <div class="d-flex align-center">
                <div class="chart-icon-bg bar-bg mr-3">
                  <v-icon color="white">mdi-chart-bar</v-icon>
                </div>
                <div>
                  <h3 class="chart-title mb-1">ตำแหน่งแยกตามประเภท</h3>
                  <p class="chart-subtitle grey--text mb-0">จำนวนตำแหน่งในแต่ละประเภท</p>
                </div>
              </div>
            </v-card-title>
            <v-card-text class="pa-6 pt-0">
              <apexchart
                type="bar"
                :options="modernBarOptions"
                :series="barSeries"
                height="350"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    

      <!-- Advanced Charts Section -->
      <v-row class="mb-6">
        <!-- Area Chart -->
        <v-col cols="12" md="8">
          <v-card class="chart-card-modern" elevation="8">
            <v-card-title class="chart-header pa-6">
              <div class="d-flex align-center justify-space-between w-100">
                <div class="d-flex align-center">
                  <div class="chart-icon-bg area-bg mr-3">
                    <v-icon color="white">mdi-chart-areaspline</v-icon>
                  </div>
                  <div>
                    <h3 class="chart-title mb-1">แนวโน้มตำแหน่งรายเดือน</h3>
                    <p class="chart-subtitle grey--text mb-0">การเปลี่ยนแปลงของตำแหน่งว่างและที่มีผู้ครอง</p>
                  </div>
                </div>
                <v-btn-toggle v-model="timeRange" color="primary" dense>
                  <v-btn small>6M</v-btn>
                  <v-btn small>1Y</v-btn>
                  <v-btn small>ALL</v-btn>
                </v-btn-toggle>
              </div>
            </v-card-title>
            <v-card-text class="pa-6 pt-0">
              <apexchart
                type="area"
                :options="areaChartOptions"
                :series="areaSeries"
                height="350"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Radial Chart -->
        <v-col cols="12" md="4">
          <v-card class="chart-card-modern" elevation="8">
            <v-card-title class="chart-header pa-6">
              <div class="d-flex align-center">
                <div class="chart-icon-bg radial-bg mr-3">
                  <v-icon color="white">mdi-chart-donut-variant</v-icon>
                </div>
                <div>
                  <h3 class="chart-title mb-1">เป้าหมายประจำปี</h3>
                  <p class="chart-subtitle grey--text mb-0">ความก้าวหน้าของเป้าหมาย</p>
                </div>
              </div>
            </v-card-title>
            <v-card-text class="pa-6 pt-0">
              <apexchart
                type="radialBar"
                :options="radialChartOptions"
                :series="radialSeries"
                height="350"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>


        <!-- Filter and Control Section -->
      <v-row class="mb-6">
        <v-col cols="12">
          <v-card class="filter-card" elevation="8">
            <v-card-title class="filter-header pa-6">
              <div class="d-flex align-center">
                <div class="filter-icon-bg mr-3">
                  <v-icon color="white">mdi-filter-variant</v-icon>
                </div>
                <div>
                  <h3 class="filter-title mb-1">ตัวกรองและการจัดการข้อมูล</h3>
                  <p class="filter-subtitle grey--text mb-0">เลือกเงื่อนไขการแสดงผลและจัดการข้อมูล</p>
                </div>
              </div>
            </v-card-title>
            <v-card-text class="pa-6">
              <v-row>
                <!-- Filter Section -->
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        label="เลือก จังหวัด"
                        :items="provinces"
                        item-text="province_name"
                        item-value="province_ID"
                        v-model="province_search"
                        filled
                        outlined
                        color="primary"
                        @change="government_employeeQuerySearchProvince()"
                        prepend-inner-icon="mdi-map-marker"
                        clearable
                      >
                        <template v-slot:selection="{ item }">
                          <v-chip small color="primary" text-color="white">
                            {{ item.province_name }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        label="เลือก วิทยาลัย"
                        :items="colleges"
                        item-text="college_name"
                        item-value="college_code"
                        v-model="college_search"
                        filled
                        outlined
                        color="primary"
                        @change="government_employeeQuerySearch()"
                        prepend-inner-icon="mdi-school"
                        clearable
                      >
                        <template v-slot:selection="{ item }">
                          <v-chip small color="success" text-color="white">
                            {{ item.college_name }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>

                <!-- Action Buttons Section -->
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-btn
                        block
                        large
                        color="info"
                        :href="'#/admin/print_report_government_employee'"
                        target="_blank"
                        class="mb-2"
                        elevation="4"
                      >
                        <v-icon left>mdi-printer</v-icon>
                        รายงานตำแหน่งว่างคงเหลือ
                      </v-btn>
                      
                      <v-btn
                        block
                        large
                        color="primary"
                        @click.native="government_employeeAdd()"
                        class="mb-2"
                        elevation="4"
                      >
                        <v-icon left>mdi-plus-circle-outline</v-icon>
                        เพิ่มรายการ
                      </v-btn>
                    </v-col>
                    
                    <v-col cols="12" md="6">
                      <v-btn
                        block
                        large
                        color="info"
                        @click.native="government_employeeQueryAll()"
                        class="mb-2"
                        elevation="4"
                      >
                        <v-icon left>mdi-format-list-bulleted</v-icon>
                        ตำแหน่งทั้งหมด
                      </v-btn>

                      <v-btn
                        block
                        large
                        color="success"
                        @click.native="government_employeeQuerynull()"
                        class="mb-2"
                        elevation="4"
                      >
                        <v-icon left>mdi-account-plus</v-icon>
                        ตำแหน่งว่าง
                      </v-btn>

                      <v-btn
                        block
                        large
                        color="warning"
                        @click.native="government_employeeUpdateJor()"
                        elevation="4"
                      >
                        <v-icon left>mdi-refresh</v-icon>
                        ปรับข้อมูลทั้งหมด
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <!-- Data Table Section -->
      <v-row class="mb-6">
        <v-col cols="12">
          <v-card class="table-card" elevation="8">
            <v-card-title class="table-header pa-6">
              <div class="d-flex align-center justify-space-between w-100">
                <div class="d-flex align-center">
                  <div class="table-icon-bg mr-3">
                    <v-icon color="white">mdi-table</v-icon>
                  </div>
                  <div>
                    <h3 class="table-title mb-1">ตารางข้อมูลอัตรากำลัง</h3>
                    <p class="table-subtitle grey--text mb-0">รายละเอียดข้อมูลตำแหน่งทั้งหมด</p>
                  </div>
                </div>
                <v-chip color="primary" text-color="white">
                  {{ government_employees.length }} รายการ
                </v-chip>
              </div>
            </v-card-title>
            <v-card-text class="pa-6">
              <v-data-table
                color="success"
                :loading="loading"
                :headers="headers"
                :items="government_employees"
                :search="search"
                class="modern-table"
                :items-per-page="25"
                :footer-props="{
                  'items-per-page-options': [25, 50, 100, -1],
                  'items-per-page-text': 'แถวต่อหน้า:'
                }"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                    single-line
                    hide-details
                    dense
                    filled
                    outlined
                    color="primary"
                    class="mb-4 search-field"
                    @keyup="idPosition_search"
                    clearable
                  />
                </template>
                
                <template v-slot:item.status_booking="{ item }">
                  <v-chip 
                    small
                    :color="item.id_card != 0 ? 'warning' : 'success'"
                    :text-color="item.id_card != 0 ? 'white' : 'white'"
                  >
                    <v-icon small left>
                      {{ item.id_card != 0 ? 'mdi-account' : 'mdi-account-plus' }}
                    </v-icon>
                    {{ item.id_card != 0 ? 'ไม่ว่าง' : 'ว่าง' }}
                  </v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    small
                    color="warning"
                    @click.stop="government_employeeEdit(item.id_no)"
                    class="mr-2"
                    fab
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                
                <template v-slot:item.action_s="{ item }">
                  <v-btn
                    small
                    color="error"
                    @click.stop="government_employeeDelete(item.id_no)"
                    fab
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="info"
                  icon="mdi-information"
                  outlined
                >
                  ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา
                </v-alert>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Dialog Sections -->
      <!--addgovernment_employeedialog  -->
      <v-layout row justify-center>
        <v-dialog
          v-model="addgovernment_employeedialog"
          persistent
          max-width="50%"
        >
          <v-card class="mx-auto pa-5 modern-dialog">
            <v-card-title class="dialog-header">
              <div class="d-flex align-center">
                <v-avatar color="primary" size="48" class="mr-3">
                  <v-icon color="white">mdi-account-plus</v-icon>
                </v-avatar>
                <div>
                  <h3 class="dialog-title">เพิ่มข้อมูลอัตรากำลังรับย้าย</h3>
                  <p class="dialog-subtitle grey--text mb-0">กรอกข้อมูลสำหรับตำแหน่งใหม่</p>
                </div>
              </div>
            </v-card-title>

            <v-card-text class="pa-6">
              <v-form ref="addgovernment_employeeform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                      <v-autocomplete
                        :items="colleges"
                        item-text="college_name"
                        item-value="college_code"
                        v-model="addgovernment_employee.college_code"
                        label="สถานศึกษา"
                        required
                        :rules="[v => !!v || 'กรุณาเลือกสถานศึกษา']"
                        outlined
                        color="primary"
                        prepend-inner-icon="mdi-school"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex md12>
                      <v-text-field
                        label="เลขที่ตำแหน่ง"
                        v-model="addgovernment_employee.id_position"
                        required
                        :rules="[v => !!v || 'กรุณากรอกเลขที่ตำแหน่ง']"
                        outlined
                        color="primary"
                        prepend-inner-icon="mdi-identifier"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md12>
                      <v-autocomplete
                        v-model="addgovernment_employee.position"
                        :items="uniquePositions"
                        item-text="position"
                        item-value="position"
                        label="ตำแหน่ง"
                        required
                        :rules="[v => !!v || 'กรุณาเลือกตำแหน่ง']"
                        outlined
                        color="primary"
                        prepend-inner-icon="mdi-account-tie"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
                <small class="text-caption grey--text">* ฟิลด์ที่จำเป็นต้องกรอก</small>
              </v-form>
            </v-card-text>
            <v-card-actions class="pa-6">
              <v-spacer></v-spacer>
              <v-btn
                color="grey"
                large
                @click.stop="addgovernment_employeedialog = false"
                outlined
                class="mr-3"
              >
                <v-icon left>mdi-close</v-icon>
                ยกเลิก
              </v-btn>
              <v-btn
                large
                color="primary"
                @click.stop="addgovernment_employeeSubmit()"
                elevation="4"
              >
                <v-icon left>mdi-content-save</v-icon>
                บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Delete Dialog -->
      <v-layout>
        <v-dialog
          v-model="deletegovernment_employeedialog"
          persistent
          max-width="40%"
        >
          <v-card class="mx-auto pa-5 modern-dialog">
            <v-card-title class="dialog-header">
              <div class="d-flex align-center">
                <v-avatar color="error" size="48" class="mr-3">
                  <v-icon color="white">mdi-delete</v-icon>
                </v-avatar>
                <div>
                  <h3 class="dialog-title">ยืนยันการลบข้อมูล</h3>
                  <p class="dialog-subtitle grey--text mb-0">การดำเนินการนี้ไม่สามารถยกเลิกได้</p>
                </div>
              </div>
            </v-card-title>

            <v-card-text class="pa-6">
              <v-alert color="error" outlined class="mb-4">
                <div class="d-flex align-center">
                  <v-icon color="error" class="mr-2">mdi-alert</v-icon>
                  <div>
                    <strong>คุณแน่ใจหรือไม่ที่จะลบข้อมูลนี้?</strong>
                    <br>
                    <span class="text-body-2">
                      {{ editgovernment_employee.college_name }} : {{ editgovernment_employee.id_position }}
                    </span>
                  </div>
                </div>
              </v-alert>
            </v-card-text>
            <v-card-actions class="pa-6">
              <v-spacer></v-spacer>
              <v-btn 
                large 
                @click.stop="deletegovernment_employeedialog = false"
                outlined
                class="mr-3"
              >
                <v-icon left>mdi-close</v-icon>
                ยกเลิก
              </v-btn>
              <v-btn
                large
                color="error"
                @click.stop="deletegovernment_employeeSubmit()"
                elevation="4"
              >
                <v-icon left>mdi-delete</v-icon>
                ลบข้อมูล
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Edit Dialog -->
      <v-layout row justify-center>
        <v-dialog
          v-model="editgovernment_employeedialog"
          persistent
          max-width="80%"
        >
          <v-card class="mx-auto pa-6 modern-dialog">
            <v-card-title class="dialog-header">
              <div class="d-flex align-center">
                <v-avatar color="warning" size="48" class="mr-3">
                  <v-icon color="white">mdi-pencil</v-icon>
                </v-avatar>
                <div>
                  <h3 class="dialog-title">แก้ไขข้อมูลอัตรากำลัง</h3>
                  <p class="dialog-subtitle grey--text mb-0">ปรับปรุงข้อมูลตำแหน่ง</p>
                </div>
              </div>
            </v-card-title>
            <v-card-text class="pa-6">
              <v-form ref="editgovernment_employeeform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12 class="text-center mb-4">
                      <v-chip color="primary" large text-color="white">
                        <v-icon left>mdi-identifier</v-icon>
                        เลขที่ตำแหน่ง: {{ editgovernment_employee.id_position }}
                      </v-chip>
                    </v-flex>

                    <v-flex md6>
                      <v-autocomplete
                        :items="colleges"
                        item-text="college_name"
                        item-value="college_code"
                        v-model="editgovernment_employee.college_code"
                        label="สถานศึกษา"
                        required
                        :rules="[v => !!v || 'กรุณาเลือกสถานศึกษา']"
                        outlined
                        color="primary"
                        prepend-inner-icon="mdi-school"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex md6>
                      <v-autocomplete
                        v-model="editgovernment_employee.name_postion"
                        :items="uniquePositions"
                        item-text="position"
                        item-value="position"
                        label="ตำแหน่ง"
                        required
                        :rules="[v => !!v || 'กรุณาเลือกตำแหน่ง']"
                        outlined
                        color="primary"
                        prepend-inner-icon="mdi-account-tie"
                      ></v-autocomplete>
                    </v-flex>


                    <v-flex md6>
                      <v-text-field
                        v-model="editgovernment_employee.id_branch_app"                     
                        label="สาขาวิชา"
                        required
                        :rules="[v => !!v || 'กรุณาระบุสาขาวิชา']"
                        outlined
                        color="primary"
                        prepend-inner-icon="mdi-account-tie"
                      ></v-text-field>
                    </v-flex>



                    <v-flex md12>
                      <v-alert type="info" outlined border="left" class="mb-0">
                        <div class="d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-information</v-icon>
                          <div>
                            <strong>ข้อมูลผู้ครองตำแหน่ง:</strong>
                            <br>
                            <span class="text-body-2">{{ fullname || 'ไม่มีผู้ครองตำแหน่ง' }}</span>
                          </div>
                        </div>
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
                <small class="text-caption grey--text">* ฟิลด์ที่จำเป็นต้องกรอก</small>
              </v-form>
            </v-card-text>
            <v-card-actions class="pa-6">
              <v-btn
                v-if="editgovernment_employee.id_card != '0'"
                color="error"
                @click="clearIdcard()"
                outlined
                class="mr-3"
              >
                <v-icon left>mdi-account-remove</v-icon>
                ให้ตำแหน่งว่าง
              </v-btn>

              <v-spacer></v-spacer>
              <v-btn
                color="grey"
                large
                @click.stop="editgovernment_employeedialog = false"
                outlined
                class="mr-3"
              >
                <v-icon left>mdi-close</v-icon>
                ยกเลิก
              </v-btn>
              <v-btn
                large
                color="primary"
                @click.stop="editgovernment_employeeSubmit()"
                elevation="4"
              >
                <v-icon left>mdi-content-save</v-icon>
                บันทึกการแก้ไข
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Snackbar -->
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        elevation="8"
        shaped
      >
        <div class="d-flex align-center">
          <v-icon large class="mr-3">{{ snackbar.icon }}</v-icon>
          <span>{{ snackbar.text }}</span>
        </div>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <!-- Detailed Stats Cards -->
      <v-row class="mb-6">
        <v-col cols="12" md="4">
          <v-card class="detail-card" elevation="8">
            <v-card-text class="pa-6">
              <div class="d-flex align-center mb-4">
                <v-avatar color="primary lighten-4" size="48">
                  <v-icon color="primary">mdi-office-building</v-icon>
                </v-avatar>
                <div class="ml-3">
                  <h4>สถานศึกษา</h4>
                  <p class="grey--text mb-0">จำนวนสถานศึกษาทั้งหมด</p>
                </div>
              </div>
              <div class="d-flex justify-space-between align-end">
                <div>
                  <div class="text-h4 primary--text">{{ totalColleges }}</div>
                  <div class="text-caption grey--text">หน่วยงาน</div>
                </div>
                <v-progress-circular
                  :value="75"
                  size="60"
                  width="4"
                  color="primary"
                >
                  75%
                </v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="detail-card" elevation="8">
            <v-card-text class="pa-6">
              <div class="d-flex align-center mb-4">
                <v-avatar color="warning lighten-4" size="48">
                  <v-icon color="warning">mdi-map-marker</v-icon>
                </v-avatar>
                <div class="ml-3">
                  <h4>จังหวัด</h4>
                  <p class="grey--text mb-0">จำนวนจังหวัดที่เข้าร่วม</p>
                </div>
              </div>
              <div class="d-flex justify-space-between align-end">
                <div>
                  <div class="text-h4 warning--text">{{ totalProvinces }}</div>
                  <div class="text-caption grey--text">จังหวัด</div>
                </div>
                <v-progress-circular
                  :value="68"
                  size="60"
                  width="4"
                  color="warning"
                >
                  68%
                </v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="detail-card" elevation="8">
            <v-card-text class="pa-6">
              <div class="d-flex align-center mb-4">
                <v-avatar color="success lighten-4" size="48">
                  <v-icon color="success">mdi-clock-check</v-icon>
                </v-avatar>
                <div class="ml-3">
                  <h4>ประสิทธิภาพ</h4>
                  <p class="grey--text mb-0">อัตราการจัดสรรตำแหน่ง</p>
                </div>
              </div>
              <div class="d-flex justify-space-between align-end">
                <div>
                  <div class="text-h4 success--text">{{ efficiencyRate }}%</div>
                  <div class="text-caption grey--text">ประสิทธิภาพ</div>
                </div>
                <v-progress-circular
                  :value="efficiencyRate"
                  size="60"
                  width="4"
                  color="success"
                >
                  {{ efficiencyRate }}%
                </v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Movementmenu_govem from "../../components/admin/movementmenu_govem.vue";

export default {
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      valid: true,
      file2: null,
      addgovernment_employeedialog: false,
      editgovernment_employeedialog: false,
      deletegovernment_employeedialog: false,
      timeRange: 1,

      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      government_employees: [],
      addgovernment_employee: {},
      editgovernment_employee: {},
      colleges: [],
      userstatus: [],
      search: "",
      pagination: {},
      headers: [
        { text: "สถานศึกษา", align: "left", value: "college_name" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "อัตราว่าง", align: "left", value: "num_position" },
        { text: "รหัสตำแหน่ง", align: "left", value: "id_position" },
        { text: "ตำแหน่ง", align: "left", value: "name_postion" },
        { text: "จอง", align: "left", value: "status_booking" },
        { text: "สถานะ", align: "left", value: "id_card" },
        { text: "ชื่อ", align: "left", value: "frist_name" },
        { text: "นามสกุล", align: "left", value: "last_name" },
        {
          text: "แก้ไข",
          align: "center",
          value: "actions",
          icon: "mdi-file-document-edit"
        }
      ],
      rowsperpage: [
        25,
        50,
        100,
        {
          text: "All",
          value: -1
        }
      ],
      college: {},
      provinces: [],
      prefectures: [],
      collgegs: [],
      government_employeestatus: [],
      regions: [],
      region_ena: true,
      data_syslog: {},
      fullname: "",
      delIppostion: {},
      college_search:'',
      province_search: '',
    };
  },
  async mounted() {
    await this.government_employeeQuerynull();
    let result;
    result = await this.$http.post("college.php", {
      ApiKey: this.ApiKey
    });
    this.colleges = result.data;
    result = await this.$http.post("province.php", {
      ApiKey: this.ApiKey
    });
    this.provinces = result.data;
    result = await this.$http.post("region.php", {
      ApiKey: this.ApiKey
    });
    this.regions = result.data;
  },
  methods: {
    async government_employeeQuerySearchProvince() {
      this.loading = true;
      try {
        let result = await this.$http.post("government_employee.php", {
          ApiKey: this.ApiKey,
          province_ID: this.province_search
        });
        this.government_employees = result.data;
      } finally {
        this.loading = false;
      }
    },
    async government_employeeQuerySearch() {
      this.loading = true;
      try {
        let result = await this.$http.post("government_employee.php", {
          ApiKey: this.ApiKey,
          college_code: this.college_search
        });
        this.government_employees = result.data;
      } finally {
        this.loading = false;
      }
    },
    async collegeQuery() {
      this.loading = true;
      try {
        let result = await this.$http.post("college.php", {
          ApiKey: this.ApiKey
        });
        this.colleges = result.data;
      } finally {
        this.loading = false;
      }
    },
    async government_employeeUpdateJor() {
      this.loading = true;
      try {
        let result = await this.$http.post(
          "government_employee.update.jor_govem.php",
          {
            ApiKey: this.ApiKey
          }
        );
        ;
      } finally {
        this.loading = false;
      }
    },
    async clearIdcard() {
      let text =
        "เลขที่ตำแหน่ง : " +
        this.editgovernment_employee.id_position +
        " โดย : " +
        this.editgovernment_employee.id_card;
      Swal.fire({
        title: "ต้องการลบข้อมูลหรือไม่?",
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.delIppostion.ApiKey = this.ApiKey;
          this.delIppostion.id_no = this.editgovernment_employee.id_no;
          this.delIppostion.id_card = this.editgovernment_employee.id_card;
          this.delIppostion.title_s = this.editgovernment_employee.title_s;
          this.delIppostion.frist_name = this.editgovernment_employee.frist_name;
          this.delIppostion.last_name = this.editgovernment_employee.last_name;
          this.delIppostion.brith_day = this.editgovernment_employee.brith_day;
          this.delIppostion.brith_month = this.editgovernment_employee.brith_month;
          this.delIppostion.brith_year = this.editgovernment_employee.brith_year;
          this.delIppostion.brith_years = this.editgovernment_employee.brith_years;
          this.delIppostion.sex = this.editgovernment_employee.sex;
          this.delIppostion.marital_status = this.editgovernment_employee.marital_status;
          this.delIppostion.bodys = this.editgovernment_employee.bodys;
          this.delIppostion.time_app = this.editgovernment_employee.time_app;
          this.delIppostion.salary_start = this.editgovernment_employee.salary_start;
          this.delIppostion.id_branch_app = this.editgovernment_employee.id_branch_app;
          this.delIppostion.regulars = this.editgovernment_employee.regulars;
          this.delIppostion.salary_s = this.editgovernment_employee.salary_s;
          this.delIppostion.level_edd = this.editgovernment_employee.level_edd;
          this.delIppostion.ed_abb = this.editgovernment_employee.ed_abb;
          this.delIppostion.ed_name = this.editgovernment_employee.ed_name;
          this.delIppostion.dmy_edd = this.editgovernment_employee.dmy_edd;
          this.delIppostion.edd_university = this.editgovernment_employee.edd_university;
          this.delIppostion.edd_country = this.editgovernment_employee.edd_country;
          let resultins = await this.$http.post(
            "government_employee.update.php",
            this.delIppostion
          );

          if (resultins.data.status == true) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการลบข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            await this.government_employeeQuerynull();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    async editgovernment_employeeFullname() {
      let title =
        this.editgovernment_employee.id_card +
        " : " +
        this.editgovernment_employee.title_s +
        this.editgovernment_employee.frist_name +
        " " +
        this.editgovernment_employee.last_name;
      this.fullname = title;
    },
    async idPosition_search(e) {
      if (e.keyCode == 13) {
        this.loading = true;
        let result = await this.$http
          .post("government_employee.php", {
            ApiKey: this.ApiKey,
            id_position: this.search
          })
          .finally(() => (this.loading = false));
        this.government_employees = result.data;
      }
    },

    async sweetAlertLoading() {
      let timerInterval;
      Swal.fire({
        title: "Auto close alert!",
        html: "I will close in <b></b> milliseconds.",
        timer: 2000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          clearInterval(timerInterval);
        }
      }).then(result => {
        if (result.dismiss === Swal.DismissReason.timer) {
        }
      });
    },
    async government_employeeQuerynull() {
      this.loading = true;
      let result = await this.$http
        .post("government_employee.php", {
          ApiKey: this.ApiKey,
          id_card_null: "ok"
        })
        .finally(() => (this.loading = false));
      this.government_employees = result.data;
    },

    async government_employeeQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("government_employee.php", {
          ApiKey: this.ApiKey
        })
        .finally(() => (this.loading = false));
      this.government_employees = result.data;
    },

    async government_employeeAdd() {
      this.addgovernment_employee = {};
      this.addgovernment_employeedialog = true;
    },
    async addgovernment_employeeSubmit() {
      if (this.$refs.addgovernment_employeeform.validate()) {
        this.addgovernment_employee.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "government_employee.insert.php",
          this.addgovernment_employee
        );
        if (result.data.status == true) {
          this.government_employee = result.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          let userSession = JSON.parse(localStorage.getItem("user")) || 0;
          this.data_syslog.ApiKey = this.ApiKey;
          this.data_syslog.user_account = userSession.user_name;
          this.data_syslog.event_log = "insert";
          this.data_syslog.page_log = "government_employee";
          this.data_syslog.table_log = "government_employee";
          this.data_syslog.detail_log =
            this.addgovernment_employee.id_position +
            ":" +
            this.addgovernment_employee.college_code;
          this.data_syslog.date_times = this.date_today_log;
          await this.$http.post("data_syslog.insert.php", this.data_syslog);
          this.government_employeeQuerynull();
        } else {
          Swal.fire({
            icon: "warning",
            title: "บันทึกข้อมูลผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
          this.government_employeeQuerynull();
        }
        this.addgovernment_employeedialog = false;
      }
    },
    async government_employeeEdit(id_no) {
      let result = await this.$http.post("government_employee.php", {
        ApiKey: this.ApiKey,
        id_no: id_no
      });

      this.editgovernment_employee = result.data;
      await this.editgovernment_employeeFullname();
      this.editgovernment_employeedialog = true;
    },
    async editgovernment_employeeSubmit() {
      if (this.$refs.editgovernment_employeeform.validate()) {
        this.editgovernment_employee.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "government_employee.update.php",
          this.editgovernment_employee
        );
        if (result.data.status == true) {
          this.government_employee = result.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          let userSession = JSON.parse(localStorage.getItem("user")) || 0;
          this.data_syslog.ApiKey = this.ApiKey;
          this.data_syslog.user_account = userSession.user_name;
          this.data_syslog.event_log = "update";
          this.data_syslog.page_log = "government_employee";
          this.data_syslog.table_log = "government_employee";
          this.data_syslog.detail_log =
            this.editgovernment_employee.id_position +
            " : " +
            this.editgovernment_employee.college_code;
          this.data_syslog.date_times = this.date_today_log;
          await this.$http.post("data_syslog.insert.php", this.data_syslog);
          this.government_employeeQuerynull();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.editgovernment_employeedialog = false;
      }
    },
    async government_employeeDelete(id_no) {
      let result = await this.$http.post("government_employee.php", {
        ApiKey: this.ApiKey,
        id_no: id_no
      });
      this.editgovernment_employee = result.data;
      this.deletegovernment_employeedialog = true;
    },
    async deletegovernment_employeeSubmit() {
      if (this.$refs.deletegovernment_employeeform.validate()) {
        this.editgovernment_employee.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "government_employee.delete.php",
          this.editgovernment_employee
        );
        if (result.data.status == true) {
          this.government_employee = result.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          let userSession = JSON.parse(localStorage.getItem("user")) || 0;
          this.data_syslog.ApiKey = this.ApiKey;
          this.data_syslog.user_account = userSession.user_name;
          this.data_syslog.event_log = "delete";
          this.data_syslog.page_log = "government_employee";
          this.data_syslog.table_log = "government_employee";
          this.data_syslog.detail_log =
            this.editgovernment_employee.id_position +
            " : " +
            this.editgovernment_employee.college_code;
          this.data_syslog.date_times = this.date_today_log;
          await this.$http.post("data_syslog.insert.php", this.data_syslog);
          this.government_employeeQuerynull();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.deletegovernment_employeedialog = false;
      }
    }
  },
  computed: {
    lastUpdated() {
      return new Date().toLocaleDateString('th-TH');
    },
    uniquePositions() {
      const positions = this.government_employees
        .map(item => item.name_postion)
        .filter(name_postion => name_postion && name_postion.trim() !== "")
        .filter(
          (name_postion, index, self) => self.indexOf(name_postion) === index
        )
        .sort()
        .map(name_postion => ({
          position: name_postion,
          text: name_postion
        }));

      return positions;
    },

    // Dashboard Statistics
    totalPositions() {
      return this.government_employees.length;
    },
    availablePositions() {
      return this.government_employees.filter(item => item.id_card == 0).length;
    },
    occupiedPositions() {
      return this.government_employees.filter(item => item.id_card != 0).length;
    },
    occupancyRate() {
      if (this.totalPositions === 0) return 0;
      return Math.round((this.occupiedPositions / this.totalPositions) * 100);
    },
    totalColleges() {
      return this.colleges.length || 0;
    },
    totalProvinces() {
      return this.provinces.length || 0;
    },
    efficiencyRate() {
      return this.occupancyRate;
    },

    // Chart Data
    donutSeries() {
      return [this.availablePositions, this.occupiedPositions];
    },
    modernDonutOptions() {
      return {
        chart: {
          type: "donut",
          fontFamily: "Sarabun, Arial, sans-serif",
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
          }
        },
        labels: ["ตำแหน่งว่าง", "ตำแหน่งที่มีผู้ครอง"],
        colors: ["#B3151B", "#424242"],
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: 'รวม',
                  formatter: () => this.totalPositions.toLocaleString()
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return Math.round(val) + "%";
          }
        },
        legend: {
          position: "bottom",
          offsetY: 10
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      };
    },

    barSeries() {
      const positionCounts = {};
      this.government_employees.forEach(item => {
        if (item.name_postion) {
          positionCounts[item.name_postion] =
            (positionCounts[item.name_postion] || 0) + 1;
        }
      });

      return [
        {
          name: "จำนวนตำแหน่ง",
          data: Object.values(positionCounts)
        }
      ];
    },
    modernBarOptions() {
      const positionCounts = {};
      this.government_employees.forEach(item => {
        if (item.name_postion) {
          positionCounts[item.name_postion] =
            (positionCounts[item.name_postion] || 0) + 1;
        }
      });

      return {
        chart: {
          type: "bar",
          fontFamily: "Sarabun, Arial, sans-serif",
          toolbar: {
            show: false
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
          }
        },
        xaxis: {
          categories: Object.keys(positionCounts)
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "60%",
            endingShape: "rounded",
            borderRadius: 4
          }
        },
        colors: ["#B3151B"],
        dataLabels: {
          enabled: false
        },
        grid: {
          borderColor: '#f1f1f1',
          strokeDashArray: 3,
          yaxis: {
            lines: {
              show: false
            }
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val.toLocaleString() + ' ตำแหน่ง';
            }
          }
        }
      };
    },

    areaSeries() {
      return [
        {
          name: 'ตำแหน่งว่าง',
          data: [320, 310, 295, 280, 270, 265, 250, 240, 235, 220, 210, 200]
        },
        {
          name: 'ตำแหน่งที่มีผู้ครอง',
          data: [930, 940, 955, 970, 980, 985, 1000, 1010, 1015, 1030, 1040, 1050]
        }
      ];
    },
    areaChartOptions() {
      return {
        chart: {
          type: 'area',
          fontFamily: 'Sarabun, Arial, sans-serif',
          toolbar: {
            show: false
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
          }
        },
        xaxis: {
          categories: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
        },
        colors: ['#B3151B', '#424242'],
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.1,
          }
        },
        stroke: {
          curve: 'smooth',
          width: 3
        },
        grid: {
          borderColor: '#f1f1f1',
          strokeDashArray: 3
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val.toLocaleString() + ' ตำแหน่ง';
            }
          }
        }
      };
    },

    radialSeries() {
      return [this.occupancyRate];
    },
    radialChartOptions() {
      return {
        chart: {
          type: 'radialBar',
          fontFamily: 'Sarabun, Arial, sans-serif'
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '60%'
            },
            dataLabels: {
              name: {
                fontSize: '16px'
              },
              value: {
                fontSize: '20px',
                formatter: function(val) {
                  return val + '%';
                }
              }
            }
          }
        },
        colors: ['#B3151B'],
        labels: ['เป้าหมายประจำปี']
      };
    },

    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear() + 543;
      let time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      today = dd + "/" + mm + "/" + yyyy + "/" + time;
      return today;
    }
  },
  components: { Movementmenu_govem }
}; 
</script>
<style scoped>
/* Hero Section */
.hero-card {
  background: linear-gradient(135deg, #d9777b 0%, #b3151b 100%);
  border-radius: 16px !important;
  overflow: hidden;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
}

.big-number {
  font-size: 4rem;
  font-weight: 700;
  line-height: 1;
}

/* Stats Cards */
.stat-card-modern {
  border-radius: 16px !important;
  border: 1px solid rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-card-modern::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #d9777b, #b3151b);
}

.stat-card-modern:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0,0,0,0.1) !important;
}

.stat-label {
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1;
}

.stat-icon-container {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.total-bg { background: linear-gradient(135deg, #d9777b, #b3151b); }
.available-bg { background: linear-gradient(135deg, #d9777b, #f5576c); }
.occupied-bg { background: linear-gradient(135deg, #90a4ae, #455a64); }
.percentage-bg { background: linear-gradient(135deg, #2e7d32, #2e7d32); }

.trend-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
}

.trend-indicator.positive {
  color: #2E7D32;
}

/* Filter Card */
.filter-card {
  border-radius: 16px !important;
  border: 1px solid rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.filter-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.1) !important;
}

.filter-icon-bg {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #d9777b, #b3151b);
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #263238;
}

.filter-subtitle {
  font-size: 0.875rem;
}

/* Table Card */
.table-card {
  border-radius: 16px !important;
  border: 1px solid rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.table-icon-bg {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #455a64, #2e7d32);
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #263238;
}

.table-subtitle {
  font-size: 0.875rem;
}

.modern-table {
  border-radius: 12px;
}

.search-field {
  border-radius: 12px;
}

/* Dialog Styles */
.modern-dialog {
  border-radius: 16px !important;
}

.dialog-header {
  border-bottom: 1px solid rgba(0,0,0,0.05);
  padding-bottom: 16px !important;
}

.dialog-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #263238;
}

.dialog-subtitle {
  font-size: 0.875rem;
}
.chart-card-modern {
  border-radius: 16px !important;
  border: 1px solid rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.chart-card-modern:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.1) !important;
}

.chart-header {
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.chart-icon-bg {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.donut-bg { background: linear-gradient(135deg, #d9777b, #b3151b); }
.bar-bg { background: linear-gradient(135deg, #d9777b, #f5576c); }
.area-bg { background: linear-gradient(135deg, #90a4ae, #455a64); }
.radial-bg { background: linear-gradient(135deg, #2e7d32, #2e7d32); }

.chart-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #263238;
}

.chart-subtitle {
  font-size: 0.875rem;
}

/* Detail Cards */
.detail-card {
  border-radius: 16px !important;
  border: 1px solid rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.detail-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.1) !important;
}

/* Gradient Background */
.gradient {
  background: linear-gradient(135deg, #d9777b 0%, #b3151b 100%);
}

/* Responsive */
@media (max-width: 768px) {
  .hero-title {
    font-size: 1.8rem;
  }
  
  .big-number {
    font-size: 2.5rem;
  }
  
  .stat-number {
    font-size: 2rem;
  }
}

/* Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dashboard-container > * {
  animation: fadeInUp 0.6s ease-out;
}

/* Progress Mini */
.progress-mini {
  width: 100%;
}
</style>